/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : 会员收款接口（收款配置 + 支付订单）</li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2026年09月25日</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';

export default {
	//收款配置（title/price/qrUrl/hasQr）
	config() {
		return Ajax.get('/payment/config')
	},
	//保存收款配置（仅 BOSS，formData 含 file/price/title）
	saveConfig(formData) {
		return Ajax.post('/payment/config', formData, {'Content-Type': 'multipart/form-data'})
	},
	//生成支付订单
	createOrder() {
		return Ajax.post('/payment/order')
	},
	//查询订单状态
	orderStatus(orderNo) {
		return Ajax.get(`/payment/order/${orderNo}`)
	},
	//二维码图片地址
	qrUrl() {
		return `${Ajax.PREFIX}/payment/qr?t=${Date.now()}`
	}
};
